import React, { useContext, useEffect } from 'react'
import Keypad from './Keypad'
import Incoming from './Incoming'
import Call from './Call'
import { SipContext } from '~/service/SipConn'
import MicrophonePermission from './MicrophonePermission'

const Phone: React.FC = ({}) => (
  <MicrophonePermission>
    <Main />
  </MicrophonePermission>
)

export default Phone

const Main: React.FC = ({}) => {
  const { registrationStatus, shownCall, incomingCall, hide } =
    useContext(SipContext)

  useEffect(() => {
    if (shownCall && shownCall.terminatedAt) {
      if (
        shownCall.id &&
        (!shownCall.isIncoming || shownCall.transferStatus != 'accepted')
      ) {
      } else {
        hide()
      }
    }
  }, [shownCall?.terminatedAt])

  if (['fail', 'loading'].includes(registrationStatus)) {
    return null
  }

  if (incomingCall && !shownCall) {
    return <Incoming call={incomingCall} />
  } else if (shownCall) {
    return <Call call={shownCall} />
  }

  return <Keypad />
}
